import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useQueries from '../../../database/useQueries';
import FormTemplate from '../../template/form/FormTemplate';
import { useSelector } from 'react-redux';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import { getFieldOptions } from '../plagins/data/commponentOptions';
import { format, parseISO } from 'date-fns';
import { GlobalContext } from '../../../App';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { fullSelectedAreaGraves, fullSelectedBlocks, fullSelectedCemeteries, fullSelectedCustomers, fullSelectedGraves, fullSelectedPlots, fullSelectedRows } from '../plagins/data/multiSelectedForm';


const NAME_ENTITY = ' קבורה';

function BurialUpdate() {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columns = useSelector((state) => state.columnsFormBurials.data);

  const { setTitle } = useContext(GlobalContext);
  const context = useContext(DataContext);
  const { setTotalWidthContainer } = useContext(TemplateContext);

  // טעינת היוזים לפונקציות עזר
  const { addOrUpdateDataBurial, getEntitiesByAttr, getEntityByAttr } = useQueries();

  // ערכי הראוטר
  const location = useLocation();
  const navigate = useNavigate();
  const { value, grave } = location.state || {};

  const [myBurial, setMyBurial] = useState(() => {
    // const val = propValue !== null ? propValue : value;
    const val = value;
    const foundItem = context?.contextBurials?.find((item) => {
      return item?.unicId === val?.unicId;
    });
    return foundItem || value;
  });

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`עדכון קבורה`);
  }, [location.pathname]);

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setLoadingData] = useState(false);

  const [cemeteries, setCemeteries] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [plots, setPlots] = useState([]);
  const [rows, setRows] = useState([]);
  const [areaGraves, setAreaGraves] = useState([]);
  const [graves, setGraves] = useState([]);
  const [clients, setClients] = useState([]);
  const [contacts, setContacts] = useState([]);

  // פונקציה לטעינת השדות מתוך הסטור
  const myColumns = (localColumns = null) => {
    localColumns = localColumns !== null ? localColumns : columns;
    return localColumns.map((field, index) => {
      let lock = false;
      lock = field.name === 'cemeteryId' || field.name === 'blockId' || field.name === 'plotId' || field.name === 'lineId' || field.name === 'areaGraveId' || field.name === 'graveId' || field.name === 'clientId' ? true : false;
      return {
        ...field,
        disabled: lock ? lock : field.disabled && grave !== undefined,
        required: field.name === 'spouse' && formValues.maritalStatus === 2 ? true : field.required || false,
        show: field?.show || false
      };
    });
  };

  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => {
    handleAllDataLoaded();
  }, [context]);

  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    setFieldsWithDynamicDisabled(myColumns());

    if (myBurial?.unicId) {
      const grave = getEntityByAttr(context?.contextGraves, 'unicId', myBurial?.graveId);

      let initialFormValues = myColumns()
        .filter((field) => field?.name)
        .reduce(
          (acc, field) => {
            let fieldValue = myBurial[field.name] || '';

            if (field.input === 'date') {
              try {
                const date = parseISO(fieldValue);
                fieldValue = format(date, 'yyyy-MM-dd');
              } catch (error) {
                fieldValue = ''; // ערך לא תקין, אפשר להחזיר ערך ריק או מה שמתאים לך
              }
            }

            return {
              ...acc,
              [field.name]: fieldValue
            };
          },
          { 
            id: myBurial?.unicId,
            unicId: myBurial?.unicId  
          }
        );

      initialFormValues = { ...initialFormValues, 
        areaGraveId: grave?.areaGraveId, lineId: grave?.lineId, plotId: grave?.plotId,
       };

      fieldAuto(grave, myBurial);

      setFormValues((prev) => {
        const updatedValues = { ...initialFormValues }; // העתקת initialFormValues כבסיס
        Object.keys(prev).forEach((key) => {
          if (prev[key] !== undefined && prev[key] !== null) {
            updatedValues[key] = prev[key]; // שמירה על הערכים הקיימים ב-prev
          }
        });
        return updatedValues;
      });
    }
  };

  // טעינת ערכים אוטומטית לשדות
  const fieldAuto = (grave, burial) => {

    const purchase = context?.contextPurchases?.find(p=> p?.clientId === burial?.clientId)

    console.log(1, purchase);

    
    
    
    let customers = context?.contextCustomers?.filter((cust) => {
      
      
      let mycust = purchase?.clientId || burial?.clientId || null;

      if (cust?.unicId !== mycust) {
        if (cust?.statusCustomer !== 2 && cust?.statusCustomer !== 3) {
          return cust;
        }
      } else {
        return cust;
      }
      return;
    });
    
    setCemeteries(fullSelectedCemeteries(context?.contextCemeteries));
    setBlocks(fullSelectedBlocks(getEntitiesByAttr(context?.contextBlocks, 'unicId', grave?.blockId)));
    setPlots(fullSelectedPlots(getEntitiesByAttr(context?.contextPlots, 'unicId', grave?.plotId)));
    setRows(fullSelectedRows(getEntitiesByAttr(context?.contextRows, 'unicId', grave?.lineId)));
    setAreaGraves(fullSelectedAreaGraves(getEntitiesByAttr(context?.contextAreaGraves, 'unicId', grave?.areaGraveId)));
    setGraves(fullSelectedGraves(getEntitiesByAttr(context?.contextGraves, 'unicId', grave?.unicId)));
    setClients(fullSelectedCustomers(customers));
    setContacts(fullSelectedCustomers(context?.contextCustomers));
  };

  const fieldChangeCemeteryId = (event, newFormValues) => {
    delete newFormValues?.blockId;
    delete newFormValues?.plotId;
    delete newFormValues?.lineId;
    delete newFormValues?.areaGraveId;
    delete newFormValues?.graveId;
    delete newFormValues?.areaGraveNameHe;
    delete newFormValues?.graveType;

    let blocks = getEntitiesByAttr(context?.contextBlocks, event.target.name, event.target.value);
    let plots = [];
    blocks.forEach((block) => {
      let tempPlots = getEntitiesByAttr(context?.contextPlots, 'blockId', block?.unicId);
      plots = plots.concat(tempPlots); // איחוד המערכים במקום הוספת מערך בתוך מערך
    });
    let rows = [];
    let areaGraves = [];

    return {
      blocks,
      plots,
      rows,
      areaGraves
    };
  };
  const fieldChangeBlockId = (event, newFormValues) => {
    delete newFormValues?.plotId;
    delete newFormValues?.lineId;
    delete newFormValues?.areaGraveId;
    delete newFormValues?.graveId;
    delete newFormValues?.areaGraveNameHe;
    delete newFormValues?.graveType;

    const block = getEntityByAttr(context?.contextBlocks, 'unicId', event.target.value);
    const cemeteryId = getEntityByAttr(context?.contextCemeteries, 'unicId', block?.cemeteryId)?.unicId;

    newFormValues = { ...newFormValues, cemeteryId };

    let plots = getEntitiesByAttr(context?.contextPlots, event.target.name, event.target.value);
    let rows = [];
    let areaGraves = [];

    return {
      newFormValues,
      plots,
      rows,
      areaGraves
    };
  };
  const fieldChangePlotId = (event, newFormValues) => {
    delete newFormValues?.lineId;
    delete newFormValues?.areaGraveId;
    delete newFormValues?.graveId;
    delete newFormValues?.areaGraveNameHe;
    delete newFormValues?.graveType;

    const plot = getEntityByAttr(context?.contextPlots, 'unicId', event.target.value);
    const block = getEntityByAttr(context?.contextBlocks, 'unicId', plot?.blockId);
    const blockId = block?.unicId;
    const cemeteryId = getEntityByAttr(context?.contextCemeteries, 'unicId', block?.cemeteryId)?.unicId;

    newFormValues = { ...newFormValues, cemeteryId, blockId };

    let rows = getEntitiesByAttr(context?.contextRows, event.target.name, event.target.value);
    let areaGraves = getEntitiesByAttr(context?.contextAreaGraves, event.target.name, event.target.value);

    return {
      newFormValues,
      rows,
      areaGraves
    };
  };

  const handleChange = (event) => {
    let newFormValues = formValues;
    if (event.target.name === 'cemeteryId') {
      let res = fieldChangeCemeteryId(event, newFormValues);
      setBlocks(res?.blocks);
      setPlots(res?.plots);
      setRows(res?.rows);
      setAreaGraves(res?.areaGraves);
    }
    if (event?.target?.name === 'blockId') {
      let res = fieldChangeBlockId(event, newFormValues);
      setPlots(res?.plots);
      setRows(res?.rows);
      setAreaGraves(res?.areaGraves);
      newFormValues = res?.newFormValues;
    }
    if (event?.target?.name === 'plotId') {
      let res = fieldChangePlotId(event, newFormValues);
      setRows(res?.rows);
      setAreaGraves(res?.areaGraves);
      newFormValues = res?.newFormValues;
    }
    setFormValues({ ...newFormValues, [event.target.name]: event.target.value });
  };

  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    columns.forEach((field) => {
      if (field.required && !formValues[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }
      if (field.notRepeat && formValues[field.name]) {
        if (plots.some((item) => item[field.name] === formValues[field.name])) {
          tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      setLoadingData(true);
      let newFormValues = { ...formValues };
      delete newFormValues?.cemeteryId;
      delete newFormValues?.blockId;
      delete newFormValues?.plotId;
      delete newFormValues?.lineId;
      delete newFormValues?.areaGraveId;

      async function executeQueries(newFormValues) {
        console.log('hiiii');

        try {
          setLoadingData(true);

          // הוספת נתוני הקבר, הלקוח, והחתימות למבנה הנתונים שנשלח לשרת
          const requestData = {
            ...newFormValues
          };

          console.log(requestData);

          // שליחת הנתונים לשרת בפנייה אחת
          let res = await addOrUpdateDataBurial(requestData);

          // בדיקת התוצאה
          if (res === 200) {
            // פעולות לאחר הצלחה
            setLoadingData(false);
            navigate(-1);
          } else {
            // טיפול במקרה של כישלון
            console.error('השאילתה נכשלה');
            setLoadingData(false);
          }
        } catch (error) {
          console.error('שגיאה בביצוע השאילתות:', error);
          setLoadingData(false);
        }
      }

      executeQueries(newFormValues);

      // console.log(newFormValues);

      // let res = await addOrUpdateDataBurial(newFormValues)
      // if (res === 200) {
      //   let updateClient = getEntityByAttr(localCustomers, 'unicId', newFormValues?.clientId)
      //   let updateGrave = getEntityByAttr(localGraves, 'unicId', value?.unicId)

      //   let resUpdateGrave = await addOrUpdateDataGrave({ ...updateGrave, graveStatus: 1 });
      //   let resUpdateClient = await addOrUpdateDataCustomer({ ...updateClient, statusCustomer: 3, graveId: value?.unicId });

      //   if (resUpdateGrave === 200 && resUpdateClient === 200) {
      //     setloadingData(false);
      //     navigate(-1);
      //   }
      // }
    }
  };

  if (loadingData) return <LoadingOverlay />;

  return (
    <FormTemplate
      title={`עריכת ${NAME_ENTITY}`}
      btn={`עדכן`}
      fields={fieldsWithDynamicDisabled}
      columns={columns}
      formValues={formValues}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      errors={errors}
      options={{
        cemeteryId: cemeteries,
        blockId: blocks,
        plotId: plots,
        lineId: rows,
        areaGraveId: areaGraves,
        graveId: graves,
        clientId: clients,
        contactId: contacts,
        plotType: getFieldOptions('plotType', optionsFields, true),
        graveType: getFieldOptions('graveType', optionsFields, true),
        resident: getFieldOptions('resident', optionsFields, true),
        priceDefinition: getFieldOptions('priceDefinition', optionsFields, true),
        buyerStatus: getFieldOptions('buyerStatus', optionsFields, true),
        isFuneralPayments: getFieldOptions('isFuneralPayments', optionsFields, true),
        numOfPayments: getFieldOptions('numOfPayments', optionsFields, true)
      }}
    />
  );
}

export default BurialUpdate;
